module.exports = __webpack_public_path__ + "img/home_cont1.4ec13401.png";